<div
  class="c09-voice-intro-screen"
  [attr.data-element]="isModal ? 'voice-page-modal' : 'voice-page-tv-screen'"
  [ngClass]="{ 'stt-disabled': !isSttEnabled }"
>
  <div class="voice-elements-container">
    <div class="speech-result" *ngIf="isSttEnabled">
      <img
        class="speech-icon"
        src="{{ baseHref }}/assets/images/voice-page/{{
          isListening ? 'voice-listening.gif' : 'voice-idle.gif'
        }}"
        alt=""
      />
      <span>{{ speechResult }}</span>
    </div>
    <h2 id="features-title" class="features-title">
      {{
        isSttEnabled
          ? isLoading
            ? copy[jsonKey.VOICE_INTRO_PLEASE_WAIT]
            : isListening
            ? copy[jsonKey.VOICE_INTRO_TRY_SAYING_COPY]
            : ''
          : copy[jsonKey.VOICE_INTRO_CHOOSE_ONE_COPY]
      }}
    </h2>
    <div class="command-buttons-container">
      <ul class="buttons-list" aria-labelledby="features-title">
        <li *ngFor="let feature of voiceSearchButtons; let index = index">
          <button (click)="onButtonClick(feature)" class="buttons" [disabled]="disableIntroButtons">
            <p class="voice-button-copy" [innerHTML]="copy.featureTitles[feature] || ''"></p>
            <img
              class="voice-icon"
              src="{{ baseHref }}/assets/images/voice-page/icon-{{ index }}.png"
              alt=""
            />
          </button>
        </li>
      </ul>
    </div>
  </div>
  <app-a04-picture-element
    *ngIf="!isModal"
    width="1920"
    height="1080"
    webpSrcset="{{ '/assets/images/voice-page/voice-search-intro-bg.webp' | assetpipe }}"
    defaultSrc="{{ '/assets/images/voice-page/voice-search-intro-bg.jpg' | assetpipe }}"
    alt="TV Intro background"
    class="voice-search-tv-intro"
  >
  </app-a04-picture-element>
</div>
